import axios from 'axios';
import apiConfig from '../shared/config/api.config';

export default function bookingSearchFormRequest(hotelId, language) {
  const {
    host,
    URIs: { bookingSearchForm, checkout },
  } = apiConfig;

  let preUri = '';
  const processType = localStorage.getItem('process-type');
  switch (processType) {
    case 'checkout':
      preUri = checkout.bookingSearchForm;
      break;
    case 'checkin':
    default:
      preUri = bookingSearchForm;
      break;
  }

  const uri = `${host}${preUri}`.replace(':hotelId', hotelId);

  return axios
    .get(uri, {
      params: {
        lang: language,
      },
    })
    .then(res => {
      return { ...res.data, lang: language };
    });
}
